import moment from "moment";
import { Icon, Text } from "components/common";
import { UserAvatar } from "components/custom/userListRow";
import { getUserProfilePath } from "constants/app-paths";
import styles from "./index.module.less";

export const notificationViewModel = (item = {}) => {
  const payload = item.payload || {};
  const actor = payload.actor || {};
  const actorName = actor.name || "Someone";
  const title = payload.title || payload.resource?.title || "this resource";
  const type = item.type || "system";
  const requestResolution = item.requestResolution || payload.follow_request_status || null;
  const copy = {
    follow_request: requestResolution === "accepted"
      ? `You accepted ${actorName}'s follow request`
      : requestResolution === "declined"
        ? `You declined ${actorName}'s follow request`
        : `${actorName} requested to follow you`,
    follow_accepted: `${actorName} accepted your follow request`,
    new_follower: `${actorName} started following you`,
    content_shared: `${actorName} recommended “${title}”`,
  };
  return {
    actor,
    actorName,
    icon: type === "content_shared" ? "BsShare" : type.startsWith("follow") || type === "new_follower" ? "FiUsers" : "UserNotification",
    title: copy[type] || payload.message || payload.title || "New notification",
    note: payload.note || payload.message_detail || "",
    timestamp: item.created_at ? moment(item.created_at).fromNow() : "",
    requestResolution,
    destination: payload.deepLink || (item.actor_user_code ? getUserProfilePath(item.actor_user_code) : null),
  };
};

const NotificationItem = ({
  item,
  onOpen,
  onAccept,
  onDecline,
  isRequestPending = false,
  isProcessing = false,
  isAccepting = false,
  isDeclining = false,
  compact = false,
}) => {
  const view = notificationViewModel(item);
  const label = `${item.is_read ? "" : "Unread notification: "}${view.title}${view.timestamp ? `, ${view.timestamp}` : ""}`;
  const showRequestActions = item.type === "follow_request" && isRequestPending && !compact;
  const content = (
    <>
      <UserAvatar user={view.actor} size={compact ? 34 : 42} />
      <div className={styles.copy}>
        <div className={styles.titleRow}>
          <Text>{view.title}</Text>
          {!item.is_read && <span className={styles.unreadDot} aria-hidden="true" />}
        </div>
        {view.note && <Text className={styles.note}>{view.note}</Text>}
        <Text className={styles.timestamp}>{view.timestamp}</Text>
      </div>
      <Icon icon={view.icon} size={15} className={styles.typeIcon} />
      {showRequestActions && (
        <div className={styles.requestActions} aria-label={`Follow request from ${view.actorName}`}>
          <button type="button" className={`${styles.requestAction} ${styles.acceptAction}`} disabled={isDeclining || (isProcessing && !isAccepting)} onClick={() => onAccept?.(item)}>
            <Icon icon="FiCheck" size={14} />{isAccepting ? "Accepting…" : "Accept"}
          </button>
          <button type="button" className={styles.requestAction} disabled={isAccepting || (isProcessing && !isDeclining)} onClick={() => onDecline?.(item)}>
            <Icon icon="IoMdClose" size={14} />{isDeclining ? "Declining…" : "Decline"}
          </button>
        </div>
      )}
      {view.requestResolution && (
        <span className={`${styles.requestOutcome} ${view.requestResolution === "accepted" ? styles.accepted : styles.declined}`}>
          <Icon icon={view.requestResolution === "accepted" ? "FiCheck" : "IoMdClose"} size={13} />
          {view.requestResolution === "accepted" ? "Accepted" : "Declined"}
        </span>
      )}
    </>
  );
  return (
    <article className={`${styles.item} ${item.is_read ? "" : styles.unread}`} aria-label={label}>
      {view.destination && !showRequestActions ? (
        <button type="button" className={styles.openButton} onClick={() => onOpen?.(item, view.destination)} aria-label={label}>{content}</button>
      ) : (
        <div className={styles.openButton}>{content}</div>
      )}
    </article>
  );
};

export default NotificationItem;
